import { render, staticRenderFns } from "./Triggers.vue?vue&type=template&id=f3153f7a&scoped=true"
import script from "./Triggers.vue?vue&type=script&lang=js"
export * from "./Triggers.vue?vue&type=script&lang=js"
import style0 from "./Triggers.vue?vue&type=style&index=0&id=f3153f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3153f7a",
  null
  
)

export default component.exports